export default __webpack_public_path__ + "static/backgroundFeatures-1a915bcb64865a0ad94ca2b8dda0ad67.jpg";